import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ReleasePlanViewer from './components/release-planner/viewer/ReleasePlanViewer';
import ReleasePlannerForm from './components/release-planner/viewer/ReleasePlannerForm';
import MonthlyPlanner from './components/monthly-planner/MonthlyPlanner';
import SimulateUI from './components/simulate-ui/Index';
import Home from './components/Home';
import DailyTasks from './components/bucket-list/DailyTasks';
import RoadmapBuilder from './components/roadmap-builder/RoadmapBuilder';
import RoadmapPlanner from './components/roadmap-planner/RoadmapPlanner';
import VelocityVisualiser from './components/velocity-visualiser/VelocityVisualiser';

export default function AppRoutes(props: any): React.ReactElement {
  const routes = createBrowserRouter([
    {
      path: '/release-planner',
      Component: ReleasePlanViewer,
    },
    {
      path: '/release-plan-editor',
      Component: ReleasePlannerForm    
    },
    {
      path: 'release-planner',
      children: [
        // {
        //   path: '',
        //   Component: ReleasePlanViewer,
        // },
        {
          path: '',
          Component: ReleasePlannerForm,
        },
      ],
    },
    {
      path: 'simulate-ui',
      children: [
        {
          path: '',
          Component: SimulateUI,
        }
      ],
    },
    {
      path: 'daily-tasks',
      children: [
        {
          path: '',
          Component: DailyTasks,
        }
      ],
    },
    {
      path: 'roadmap-builder',
      children: [
        {
          path: '',
          Component: RoadmapBuilder,
        }
      ],
    },
    {
      path: 'roadmap-planner',
      children: [
        {
          path: '',
          Component: RoadmapPlanner,
        }
      ],
    },
    {
      path: 'monthly-planner',
      children: [
        {
          path: '',
          Component: MonthlyPlanner,
        }
      ],
    },
    {
      path: 'velocity-visualiser',
      children: [
        {
          path: '',
          Component: VelocityVisualiser,
        }
      ],
    },
    {
      path: '*',
      Component: Home,
    },
  ]);

  return <RouterProvider router={routes} />;
}
